module.exports = __webpack_public_path__ + "img/xzyyjtgzh.2cefc5bd.jpg";